import styled from 'styled-components';
import { BoardCardProps } from './interfaces';

export const StyledCard = styled.div<BoardCardProps>`
  border: 1px solid #e2e2e5;
  width: 100%;
  position: relative;
  background: ${({ theme }) => theme.colors.neutral[0]};
  display: flex;
  flex-direction: column;
  justify-content: start;
  margin-bottom: 24px;
  border-radius: 4px;
  overflow: hidden;
  cursor: default;

  ${({ theme, disableHoverState }) =>
    !disableHoverState &&
    `&:hover {
    	border-color: ${theme.colors.neutral[900]};
  	}`}

  ${({ theme, forceActiveState }) =>
    forceActiveState &&
    `
    	border-color: ${theme.colors.neutral[900]};
			box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);
  	`}
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px;

  @media (max-width: ${({ theme }) => theme.screens.mobile}) {
    padding: 12px;
  }
`;

type ThumbnailWrapperProps = {
  customImage?: boolean;
};

export const ThumbnailWrapper = styled.div<ThumbnailWrapperProps>`
  overflow: hidden;
  width: 100%;
  position: relative;
  background: #fafafa;
  display: block;

  ${({ customImage }) =>
    !customImage &&
    `
			display: flex;
			justify-content: center;
			aspect-ratio: 1920 / 1080;
	`}

  img {
    transform: scale(1.01);
  }

  #thumbnail-image-fallback {
    object-fit: contain;
    min-width: 100%;
    max-width: 100%;
    min-height: 100%;
    max-height: 100%;
  }
`;
